import styles from './Card.module.css'
import classNames from 'classnames'
import React from 'react'

export interface CardProps {
  children: React.ReactNode
  hasShadow?: boolean
}

export const Card = ({ children, hasShadow }: CardProps) => {
  const CardClasses = classNames(styles.Card, {
    [styles['Card--has-shadow']]: hasShadow,
  })

  return (
    <div className={CardClasses}>
      <div className={styles.Card__body}>{children}</div>
    </div>
  )
}
